// Preloader.js
import React, { useEffect, useState } from 'react';

const Preloader = () => {
    
    return (
      <div id="preloader">
        <style>{`
                
                
                #preloader-status {
                    text-align: center;
                }

            `}</style>
        <div id="preloader-status">
          <div className="preloader-logo">
            <img
              src={`${process.env.PUBLIC_URL}/img/logo2.jpg`}
              className="logo-img"
              alt="Logo"
              style={{ width: "40%" }}
            />
          </div>

          <div className="preloader-position loader">
            <span></span>
          </div>
        </div>
      </div>
    );
};

export default Preloader;
